import { clsx as d } from "clsx";
import { Fragment as n, jsx as a, jsxs as _ } from "react/jsx-runtime";
var v = "_label_a3otn_1", m = "_small_a3otn_10", s = {
  label: v,
  default: "_default_a3otn_6",
  small: m
}, c = ({ variant: r = "default", children: l, className: t }) => /* @__PURE__ */ a("div", {
  className: d(s.label, s[r], t),
  children: l
}), p = "_separator_qi3ml_1", u = "_separatorContainer_qi3ml_17", f = "_line_qi3ml_29", b = "_text_qi3ml_38", e = {
  separator: p,
  separatorContainer: u,
  line: f,
  text: b
}, h = ({ visible: r = !0, text: l = "", noMargin: t = !1, color: o }) => {
  const i = o ? { "--horizontal-separator-color": o } : void 0;
  return /* @__PURE__ */ a(n, { children: l ? /* @__PURE__ */ _("div", {
    className: e.separatorContainer,
    "data-no-margin": t || void 0,
    style: i,
    children: [
      /* @__PURE__ */ a("div", {
        className: e.line,
        "data-visible": r || void 0
      }),
      /* @__PURE__ */ a(c, { children: /* @__PURE__ */ a("span", {
        className: e.text,
        children: l
      }) }),
      /* @__PURE__ */ a("div", {
        className: e.line,
        "data-visible": r || void 0
      })
    ]
  }) : /* @__PURE__ */ a("div", {
    className: e.separator,
    "data-visible": r || void 0,
    "data-no-margin": t || void 0,
    style: i
  }) });
};
export {
  h as t
};
